import type { ReactNode } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import ScrollToTop from "@/components/feature/ScrollToTop";
import BackToTop from "@/components/feature/BackToTop";

export default function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <ScrollToTop />
      <SiteHeader />
      <main className="w-full flex-1">{children}</main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}